<template>
    <div>
        <div class="nixia-fab" @click="toggleChat">
            <i class="fa-duotone fa-solid fa-microchip-ai"></i>
        </div>


        <transition name="fade">
            <div v-if="open" class="nixia-window">
                <div class="nixia-header">
                    <div class="nixia-header-left">
                        <i class="fa-duotone fa-solid fa-microchip-ai"></i>
                        <span>Nixia - Inteligência que simplifica</span>
                    </div>
                    <i class="fa-solid fa-xmark nixia-close" @click="toggleChat"></i>
                </div>

                <div class="nixia-chat" ref="box">
                    <div v-for="(m, index) in messages" :key="index" :class="['msg', m.from]">
                        <div class="bubble" v-html="m.text"></div>
                    </div>

                    <div v-if="typing" class="typing">
                        <span></span><span></span><span></span>
                    </div>
                </div>

                <div class="nixia-input-row">
                    <input v-model="question" @keyup.enter="send" placeholder="Digite sua pergunta..."
                        class="nixia-input" />

                    <button class="nixia-btn-send" @click="send">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>

                    <button class="nixia-btn-audio" @click="fakeAudio">
                        <i class="fa-solid fa-microphone"></i>
                    </button>


                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "IA",

    data() {
        return {
            open: false,
            question: "",
            typing: false,
            messages: []
        };
    },

    methods: {
        toggleChat() {
            this.open = !this.open;

            if (this.open) {
                this.$emit("activated", true);
                this.scroll();
            }
        },

        send() {
            if (!this.question.trim()) return;

            const q = this.question;
            this.question = "";

            this.messages.push({ from: "user", text: q });
            this.scroll();

            this.typing = true;

            setTimeout(() => this.fakeResponse(q), 800);
        },

        fakeAudio() {
            alert("🎤 Áudio fake ativado (mock)");
        },

        fakeResponse(q) {
            let r = "";

            const t = q.toLowerCase();

            if (t.includes("onde está")) {
                r = `
          Localização atual do produto solicitado:<br>
          • Cliente <b>Studio X</b><br>
          • Última movimentação: <b>retornou ao estoque</b> hoje às 09:12
        `;
            } else if (t.includes("contas") || t.includes("pagar")) {
                r = `
          Hoje você tem 3 contas a pagar:<br>
          • Energia — R$ 620,00<br>
          • Internet — R$ 159,00<br>
          • Assinatura Nixloc — R$ 299,00
        `;
            } else if (t.includes("entrega")) {
                r = `
          Entregas de hoje:<br>
          • Kit Iluminação — Cliente Audiomap<br>
          • Projetor 5K — Light Vision
        `;
            } else if (t.includes("alterou")) {
                r = `
          A última alteração da locação #4829 foi feita por <b>Márcio</b> às 14:33.
        `;
            } else {
                r = `Aqui é a Nixia 🤖<br>Sou um mock, mas já consigo simular fluxo do Nixloc!`;
            }

            this.animateTyping(r);
        },

        animateTyping(text) {
            this.typing = true;

            let i = 0;
            let current = "";

            const timer = setInterval(() => {
                current += text[i];
                i++;

                if (i >= text.length) {
                    clearInterval(timer);

                    this.typing = false;
                    this.messages.push({ from: "nixia", text });
                    this.scroll();
                }
            }, 8);
        },

        scroll() {
            this.$nextTick(() => {
                const box = this.$refs.box;
                box.scrollTop = box.scrollHeight;
            });
        }
    }
};
</script>

<style scoped>
.nixia-fab {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #2563eb;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
    z-index: 9999;
}

.nixia-window {
    position: fixed;
    bottom: 100px;
    right: 26px;
    width: 460px;
    height: 520px;
    background: white;
    border-radius: 14px;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 9999;
}

.nixia-header {
    background: #577696;
    padding: 12px 16px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.nixia-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    font-size: 15px;
}

.nixia-close {
    cursor: pointer;
    font-size: 20px;
}


.nixia-chat {
    flex: 1;
    padding: 16px;
    background: #f8fafc;
    overflow-y: auto;
}

.msg {
    width: 100%;
    margin-bottom: 14px;
    display: flex;
}

.msg.user {
    justify-content: flex-end;
}

.msg.nixia {
    justify-content: flex-start;
}

.bubble {
    max-width: 80%;
    padding: 12px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 1.4;
}

.user .bubble {
    background: #2563eb;
    color: white;
}

.nixia .bubble {
    background: #e2e8f0;
    color: #1e293b;
}

.nixia-input-row {
    display: flex;
    padding: 12px;
    gap: 10px;
    background: #F9FAFB;
    border-top: 1px solid #E5E4E8;
}

.nixia-input {
    flex: 1;
    padding: 10px 12px;
    border: 1px solid #E5E4E8;
    border-radius: 50px;
    background: white;
    outline: none;
}

.nixia-btn-send,
.nixia-btn-audio {
    width: 46px;
    height: 46px;
    border: none;
    border-radius: 50px;
    color: white;
    cursor: pointer;
}

.nixia-btn-send {
    background: #2563eb;
}

.nixia-btn-audio {
    background: #475569;
}


.typing {
    display: flex;
    gap: 5px;
    padding: 10px;
}

.typing span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #94a3b8;
    animation: blink 1s infinite alternate;
}

.typing span:nth-child(2) {
    animation-delay: .2s;
}

.typing span:nth-child(3) {
    animation-delay: .4s;
}

@keyframes blink {
    from {
        opacity: .2;
    }

    to {
        opacity: 1;
    }
}

/* FADE TRANSITION */
.fade-enter-active,
.fade-leave-active {
    transition: opacity .25s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
